import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../app.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {


  lang$: any;
  languages: Array<string> = [];
  loadingLanguages = false;
  trans$: any;
  selectedLang = 'en';


  constructor(
    private appService: AppService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    localStorage.setItem('lang', this.selectedLang);
    this.trans$ = this.appService.selectedLang.subscribe((l) => {
      this.selectedLang = l;
    });
    this.lang$ = this.appService.languages.subscribe(
      (l) => {
        this.languages = l;
      }
    );
    this.getLanguages();

  }

  ngOnDestroy() {
    this.lang$.unsubscribe();
    this.trans$.unsubscribe();
  }

  getLanguages() {
    this.loadingLanguages = true;
    this.appService.getLanguages().subscribe(() => { this.loadingLanguages = false; }, () => { this.loadingLanguages = false; });
  }

  onLangChange() {
    localStorage.setItem('lang', this.selectedLang);
    this.appService.selectedLang.next(this.selectedLang);
    this.translate.use(this.selectedLang);
    console.log('Lang changed');
  }

  onNewReference() {
    this.appService.reference.next(null);
    this.router.navigateByUrl('/references/form');
  }

  goHome() {
    this.router.navigateByUrl('/references/search');
  }

}
